import { render, staticRenderFns } from "./Form65AbamaLinkRoom.vue?vue&type=template&id=ff4433d0&scoped=true&"
import script from "./Form65AbamaLinkRoom.vue?vue&type=script&lang=js&"
export * from "./Form65AbamaLinkRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4433d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VIcon,VToolbar,VToolbarTitle})
